export default __webpack_public_path__ + "slices/main/assets/public/media/logo-enso-square.7f7348f6d02c532f7105f49b831b70f3.png";